
const REACT_APP_SBMA_ASSETS_ADMIN_API_ENDPOINT = process.env.REACT_APP_SBMA_ASSETS_API_ENDPOINT + "/api/v1/device";
const GATE_SERVICE_BASE_URL = process.env.REACT_APP_SBMA_ASSETS_API_ENDPOINT + "/api/v1/gate"

export default {

    // User
    DEVICE_LIST:            REACT_APP_SBMA_ASSETS_ADMIN_API_ENDPOINT + "/list",
    UPDATE_STATUS:          REACT_APP_SBMA_ASSETS_ADMIN_API_ENDPOINT + "/update/status",
    UPDATE_DEVICE:          REACT_APP_SBMA_ASSETS_ADMIN_API_ENDPOINT + "/update",
    UPDATE_ENTRY_TYPE:      REACT_APP_SBMA_ASSETS_ADMIN_API_ENDPOINT + "/update/entry-type",
    FILTER_DEVICE_LIST:     REACT_APP_SBMA_ASSETS_ADMIN_API_ENDPOINT + "/filter",


    // Gate
    GATE_FILTER_LIST:       GATE_SERVICE_BASE_URL + "/list"
}
